<template>
	<a href="#" class="btn btn-white active" @click="generateCSV">
		<i class="fas fa-file-csv"></i>
	</a>
</template>

<script>
	export default {
		methods: {
			async generateCSV() {

        this.$toasted.show("<i class='fas fa-file-csv'></i> ¡Generando archivo .csv!", { 
           theme: "toasted-primary", 
           position: "bottom-left", 
           duration : 2000
        });

				const url = 'integralit.test/api/newsletter/export';
				const settings = {
					method: 'GET'
				};
				const response = await fetch(`http://${url}`);
				const responseData = await response.blob();

				const data = window.URL.createObjectURL(responseData);
				const link = document.createElement('a');
				link.href = data;
				link.setAttribute('download', 'emails.csv');
				document.body.appendChild(link);
				link.click();
			},
		}
	}
</script>